import { createSettingsContextProvider } from "@faire/web--source/common/settings/hooks/createSettingsContextProvider";

export const { useSetting, SettingsContextProvider, useAssignSetting } =
  createSettingsContextProvider<"HELP_CENTER">();
